import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';

import { ButtonModule } from './../../../common/button/button.module';
import { IconModule } from './../../../common/icon/icon.module';
import { AttachmentItemModule } from './../attachment-item/attachment-item.module';
import { FileUploadComponent } from './file-upload.component';

@NgModule({
  declarations: [FileUploadComponent],
  exports: [FileUploadComponent],
  imports: [AttachmentItemModule, CommonModule, ButtonModule, IconModule],
})
export class FileUploadModule {}
export { FileUploadComponent } from './file-upload.component';
